module.exports = __webpack_public_path__ + "img/rec-10.a76d9916.png";